module.exports = __webpack_public_path__ + "static/media/SPADE.de25f269.png";